<template>
<!-- 新增纠错审核 -->
  <div class="custom_data_check" v-loading="pageLoading">
    <div class="cus_main_page">
    <div class="inner-wrap">
      <div class="info_list">
        <div class="info_title">基本信息</div>
        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">申请人:</div>
            <div class="info_item_text">{{member_truename}}</div>
          </div>
          <div class="info_item_right">
            <div class="info_item_label">申请时间:</div>
            <div class="info_item_text">{{update}}</div>
          </div>
        </div>
      </div>

      <div class="info_list">
        <div class="info_title">原信息</div>
        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">客户名称-标准化:</div>
            <div class="info_item_text">{{name}}</div>
          </div>
          <div class="info_item_right">
            <div class="info_item_label">省/市/区县-标准化:</div>
            <div class="info_item_text">{{p_name}}{{city_name}}{{ad_name}}</div>
          </div>
        </div>

        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">药聚汇等级-标准化:</div>
            <div class="info_item_text">{{dj}}</div>
          </div>
          <div class="info_item_right">
            <div class="info_item_label">终端分类-标准化:</div>
            <div class="info_item_text">{{org_type_2_text}}</div>
          </div>
        </div>

        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">终端类别-标准化:</div>
            <div class="info_item_text">{{org_type_3_text}}</div>
          </div>
          <div class="info_item_right">
            <div class="info_item_label">终端类型-标准化:</div>
            <div class="info_item_text">{{org_type_4_text}}</div>
          </div>
        </div>

        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">是否军区-标准化:</div>
            <div class="info_item_text">{{is_junqu}}</div>
          </div>
          <div class="info_item_right">
            <div class="info_item_label">网站链接-标准化:</div>
            <div class="info_item_text">{{frontend_original_url}}</div>
          </div>
        </div>

        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">定级-标准化:</div>
            <div class="info_item_text">{{le_type_2_text}}</div>
          </div>
          <div class="info_item_right">
            <div class="info_item_label">定等-标准化:</div>
            <div class="info_item_text">{{le_type_3_text}}</div>
          </div>
        </div>

        <div class="info_item">
          <div class="info_item_left">
            <div class="info_item_label">所有制形式-标准化:</div>
            <div class="info_item_text">{{reg_type_2_text}}</div>
          </div>
        </div>
      </div>

      <div class="info_list">
        <div class="info_title">修改后信息</div>
        <div class="info_item" v-for="(obj, index) in newInfo" :key="index">
          <div class="info_item_left" v-if="obj[0]">
            <div class="info_item_label">{{obj[0].title}}:</div>
            <div class="info_item_text">{{obj[0].after}}</div>
          </div>
          <div class="info_item_right" v-if="obj[1]">
            <div class="info_item_label">{{obj[1].title}}:</div>
            <div class="info_item_text">{{obj[1].after}}</div>
          </div>
        </div>
      </div>

      <div class="info_list">
        <div class="info_title">凭证截图</div>
        <div class="img_list">
            <img :src="curPreSrc + img.path" alt="" v-for="(img, index) in imgList" :key="index">
            <!-- 预览 -->
            <div class="img_ope" @click="previewShow = true" v-if="imgList.length">预览</div>
        </div>
      </div>
    </div>

     <!-- 历史 -->
    <!-- <div class="record_history">
      <div class="record_history_title">审核记录</div>
      <div class="record_history_item" v-for="(record, index) in history_records" :key="index">
        <div class="record_history_time">{{record.create_time}}</div>
        <div class="record_history_ope">{{record.do_member_truename}} {{record.message_type}}</div>
        <div class="record_history_msg" v-if="record.message_content !== ''">意见说明: {{record.message_content}}</div>
      </div>
    </div> -->
    </div>
    <!-- 查看图片弹框 -->
    <div class="fix_chakan_img" v-if="chakanShow">
      <div class="chakan_img_wrap">
        <img :src="curPreSrc + pingzheng" alt="">
      </div>
      <i class="chakan_img_close iconquxiao iconfont" @click="chakanShow = false"></i>
    </div>
    <!-- 底部操作项 -->
    <page-bottom-line text="提交保存" @confirm="submit" pageType="newapply">
        <Button @click="bohuiDiag">驳回</Button>
        <Button @click="confirmPass" type="primary" :disabled="checkSending">通过</Button>
    </page-bottom-line>
    <!-- 拒绝弹框 -->
    <simple-diag
      class="submit-error-diag"
      width="400px"
      title="驳回原因"
      confirmText="提交"
      :isShow="show"
      @close="close"
      @confirm="confirm"
    >
      <div class="check_custom_diag_wrap">
        <span class="error-describe" :class="{ 'is-red': isRed }"><i>{{content.length || 0}}</i>/200</span>
        <Input
          type="textarea"
          placeholder="请输入内容"
          v-model.trim="content"
          :maxlength="200"
          show-word-limit
          resize="none"
          class="check_custom_data_img"
        />
      </div>
    </simple-diag>
    <!-- previewImg -->
    <preview-img
      v-if="previewShow"
      :imgList="previewImgList"
      @close="previewShow = false"
    ></preview-img>
  </div>
</template>
<script>
import '@/components/vue-easytable/themes-base/index.css'
import pageBottomLine from '@/components/pageCom/pageBottomLine.vue'
import simpleDiag from '@/components/dialogs/simpleDiag.vue'
import { getCustomCheckInfo, customJiuReject, customJiuPass } from '@/api/goodStand.js'
import previewImg from '@/components/yjhUpload/previewImg'
export default {
  name: 'customJiuCheck',
  components: { pageBottomLine, simpleDiag, previewImg },
  data() {
    return {
      pageLoading: false, // 页面loading
      chakanShow: false,
      show: false, // 弹框是否显示
      content: '', // 拒绝原因
      member_truename: '', // 上传人
      update: '', // 更新时间
      name: '', // 客户名称
      org_type_3: '', // 判断是不是医院 11 代表医院
      org_type_3_text: '', // 终端类型
      org_type_4_text: '', // 终端类别
      reg_type_1_text: '', // 经营性质
      org_type_2_text: '',
      dj: '', // 药聚汇等级
      is_junqu: '', // 是否军区
      p_name: '',
      city_name: '',
      ad_name: '',
      address: '',
      pingzhengName: '', // 凭证名字
      pingzheng: '', // 截图凭证
      frontend_original_url: '', // 原始链接地址
      checkSending: false,
      newInfo: [], // 修改信息 2020-10-29
      imgList: [], // 凭证截图
      history_records: [],
      previewShow: false,
      previewImgList: [],
      le_type_2_text: '', // 定级
      le_type_3_text: '', // 定等
      reg_type_2_text: '', // 所有制形式
      isSendReject: false
    }
  },
  computed: {
    isRed() {
      return this.content && (this.content.length === 200)
    },
    curPreSrc() {
    //   return process.env.NODE_ENV === 'development' ? 'https://test.data.pharmconverge.com/' : 'https://data.pharmconverge.com/'
      return process.env.VUE_APP_ADD_PRE
    }
  },
  mounted() {
    this.$store.commit('SET_RETURN_TITLE', '纠错数据审核')
    this.$store.commit('SET_RETURN_URL', '/qiyeStand/kehuData/4')
    this.$store.commit('SET_RETURN_TYPE', 'check')
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.pageLoading = true
      getCustomCheckInfo({
        id: this.$route.params.id
      }).then(res => {
        this.pageLoading = false
        if (res.code === 0) {
          const data = res.result.old_info
          this.member_truename = res.result.member_truename
          this.update = res.result.shenqing_shijian
          this.name = data.name
          this.org_type_2 = data.org_type_2
          this.org_type_3 = data.org_type_3
          this.org_type_3_text = data.org_type_3_text
          this.org_type_4_text = data.org_type_4_text
          this.reg_type_1_text = data.reg_type_1_text
          this.dj = data.dj
          this.is_junqu = data.is_junqu
          this.p_name = data.p_name
          this.city_name = data.city_name
          this.ad_name = data.ad_name
          this.address = data.address
          this.le_type_2_text = data.le_type_2_text || ''
          this.le_type_3_text = data.le_type_3_text || ''
          this.reg_type_2_text = data.reg_type_2_text || ''
          this.pingzhengName = res.result.frontend_screen_img_attach[0] ? res.result.frontend_screen_img_attach[0].origin_name : ''
          this.pingzheng = res.result.frontend_screen_img_attach[0] ? res.result.frontend_screen_img_attach[0].path : ''
          this.frontend_original_url = data.frontend_original_url

          // 下面是处理变更信息
          if (res.result.new_info.length) {
            const totalArr = []
            let i = 0
            let tmpArr = []
            res.result.new_info.forEach((info) => {
              if (info.title && info.title !== '省' && info.title !== '市') {
                if (info.title === '区/县') {
                  const title = '省/市/区县'
                  const area = []
                  res.result.new_info.forEach(info2 => {
                    if (info2.title === '省') {
                      area[0] = info2.after
                    } else if (info2.title === '市') {
                      area[1] = info2.after
                    } else if (info2.title === '区/县') {
                      area[2] = info2.after
                    }
                  })
                  tmpArr.push({
                    title,
                    after: area.join('')
                  })
                } else {
                  tmpArr.push(info)
                }
                i++
                if (i === 2) {
                  totalArr.push(tmpArr)
                  i = 0
                  tmpArr = []
                }
              }
            })
            if (tmpArr.length === 1) {
              totalArr.push(tmpArr)
            }
            this.newInfo = totalArr
          }
          this.imgList = res.result.frontend_screen_img_attach
          this.previewImgList = res.result.frontend_screen_img_attach.map(obj => {
            return {
              src: `${this.curPreSrc}${obj.path}`
            }
          })
          // const recordsOpe = {
          //   '10': '驳回新增申请', '20': '通过新增申请', '30': '驳回纠错申请', '40': '通过纠错申请',
          //   '50': '驳回删除申请', '60': '通过删除申请', '70': '驳回恢复申请', '80': '通过恢复申请'
          // }
          // this.history_records = res.result.check_line.map(obj => {
          //   if (obj.message_type) {
          //     obj.message_type = recordsOpe[obj.message_type]
          //   }
          //   return obj
          // })
        }
      })
    },
    chakanFn(flag) { // 点击查询图片
      this.chakanShow = flag
    },
    submit() {
    },
    close() {
      this.show = false
      this.content = ''
    },
    confirm() { // 确定驳回
      if (this.content === '') {
        this.$Message.info('请输入驳回原因')
        return
      }
      if (this.isSendReject) return
      this.isSendReject = true
      customJiuReject({
        id: this.$route.params.id,
        backend_reject_msg: this.content
      }).then(res => {
        this.isSendReject = false
        if (res.code === 0) {
          this.$Message.info('驳回成功')
          this.show = false
          this.content = ''
          this.$router.push('/qiyeStand/kehuData/4')
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    bohuiDiag() {
      this.show = true
    },
    confirmPass() { // 通过审核
      if (this.checkSending) return
      this.checkSending = true
      customJiuPass({
        id: this.$route.params.id
      }).then(res => {
        this.checkSending = false
        if (res.code === 0) {
          this.$Message.info('通过审核')
          this.$router.push('/qiyeStand/kehuData/4')
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    initTableScroll() {
      document.querySelector('.v-table-body').scrollLeft && (document.querySelector('.v-table-body').scrollLeft = 0)
      document.querySelector('.v-table-header').scrollLeft && (document.querySelector('.v-table-header').scrollLeft = 0)
    },
    // 原始凭证-跳转
    changeUrl() {
      if (this.frontend_original_url.includes('http')) {
        window.open(this.frontend_original_url)
      } else {
        window.open('http://' + this.frontend_original_url)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
/deep/ .el-loading-mask {
    z-index: 0;
}
.cus_main_page {
  // display: flex;
  // justify-content: center;
}
.inner-wrap {
  width: 900px;
  margin: -20px 0 0 10px;
  background: $white;
  padding: 0 30px;
  // margin-left: calc(50% - 555px);
  margin-left: calc(50% - 450px);
}
.info_list {
  padding: 30px 0 10px 0;
  border-bottom: 1px solid #F2F7FB;
  &_last {
    padding-bottom: 0px;
    position: relative;
  }
  .info_title {
    height: 14px; font-size: 14px; line-height: 14px; color: #5d6f80;
    font-weight: 600; margin-bottom: 24px;
  }
  .info_item {
    display: flex;
    margin-bottom: 20px;
  }
  .info_item_left {
    display: flex;
    width: 430px;
    position: relative;
  }
  .info_item_right {
    width: 410px;
    display: flex;
    position: relative;
  }
  .info_item_label {
    width: 120px;
    text-align: right;
    font-size: 12px;
    line-height: 18px;
    margin-right: 10px;
  }
  .info_item_text {
    flex: 1;
    font-size: 12px;
    line-height: 18px;
    // white-space: wrap;
    position: absolute;
    width: 100%;
    padding-left: 130px;
    white-space: normal;
    word-break:break-all;

    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    a { color: $blue; text-decoration: underline; }
  }
  .info_item_text-ping {
    max-width: 400px;
    padding-right: 50px;
    width: auto !important;
  }
  .info_item_text-ping-label {
    max-width: 228px;
  }
  .chakan {
    position: absolute; right: 0px; top: 0px; color: $blue;
    text-decoration: underline; cursor: pointer;
  }
}
.info_list_last {
  position: relative;
  .search_area_wrap {
    position: absolute;
    width: 220px;
    height: 32px;
    right: 0px;
    top: 22px;
    /deep/ .ivu-input-wrapper {
      height: 32px;
      line-height: 32px;
      .ivu-input {
        height: 32px;
        line-height: 32px;
        padding-right: 26px;
      }
    }
    .iconfont {
      position: absolute;
      right: 8px;
      top: 8px;
      cursor: pointer;
    }
  }
}
.ivu-btn {
  width: 68px;
  height: 28px;
}
.fix_chakan_img {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, .3);
  z-index: 1000;
  .chakan_img_wrap {
    width: 970px;
    height: 580px;
    position: absolute;
    top: 100px;
    left: 50%;
    margin-left: -485px;
    padding: 20px;
    background: $white;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .chakan_img_close {
    color: #C1CFDB;
    font-size: 28px;
    position: absolute;
    width: 28px;
    height: 28px;
    right: 60px;
    top: 60px;
    cursor: pointer;
    z-index: 100;
  }
}
/deep/ .v-table-header:before  {
  display: none;
}
/deep/ .v-table-title-cell {
  font-weight: 600;
}
</style>
<style lang="scss">
@import '@/styles/color.scss';
.check_custom_diag_wrap {
  box-sizing: border-box;
  position: relative;
  margin: 0 20px;
  padding: 6px 0px 0 10px;
  border: 1px solid #BECAD6;
  height: 128px;
  /deep/ .error-describe {
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 12px;
    line-height: 12px;
    i {
      font-style: normal;
    }
  }
  /deep/ .is-red {
    i {
      color: $red;
    }
  }
}
.check_custom_data_img {
  border: none;
  /deep/ .ivu-input {
    width: 100%;
    height: 90px;
    padding: 0;
    font-size: 13px;
    border: none;
    color: #333333;
    resize:none;
  }
}
.info_item_left_img {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.img_list {
  img {
    display: inline-block;
    width: 80px;
    height: 80px;
    margin-right: 10px;
  }
  .img_ope {
    display: inline-block;
    margin-left: 10px;
    color: $blue;
    text-decoration: underline;
    cursor: pointer;
  }
}
.record_history {
    position: fixed;
    top: 60px;
    left: calc(50% + 345px);
    width: 210px;
    padding-top: 16px;
    background: #FFF;
    box-shadow: 0px 2px 4px 0px rgba(135, 150, 176, 0.06);
    margin-left: 10px;
    margin-top: 20px;
    max-height: calc(100% - 160px);
    overflow: auto;
    .record_history_title {
      font-size: 14px;
      line-height: 14px;
      color: #5D6F80;
      padding-left: 12px;
      padding-bottom: 20px;
    }
    .record_history_item {
      margin-left: 16px;
      padding-left: 12px;
      padding-bottom: 20px;
      font-size: 12px;
    //   border-left: 2px solid #E9EFF4;
      position: relative;
      &:before {
        display: block;
        content: '';
        position: absolute;
        height: 100%;
        width: 2px;
        background: #E9EFF4;
        left: 0px;
        top: 0px;
      }
      &:after {
        display: block;
        content: '';
        position: absolute;
        left: -2px;
        top: 3px;
        width: 6px;
        height: 6px;
        border-radius: 100%;
        background: #1881DC;
      }
      &:nth-last-child(1) {
        &:before {
          height: 20px;
        }
      }
      .record_history_time {
        margin-bottom: 10px;
        line-height: 12px;
      }
      .record_history_ope {
        color: #5D6F80;
        line-height: 12px;
        font-weight: 600;
      }
      .record_history_msg {
        margin-top: 8px;
        line-height: 16px;
        color: #B5C2D0;
      }
    }
}
</style>
